import { createContext, useContext } from 'react';
import type { tRadioCardContext } from './RadioCard.types';

/**
 * Scoped to a single RadioCardGroup — it carries the shared `name`, the
 * selection and the disabled/invalid state down to each card, so callers can
 * compose arbitrary children without wiring those props card by card.
 */
export const RadioCardContext = createContext<tRadioCardContext | null>(null);

export function useRadioCardGroup(): tRadioCardContext {
  const context = useContext(RadioCardContext);

  if (!context) {
    throw new Error('RadioCard must be rendered inside a RadioCardGroup.');
  }

  return context;
}
